import React, { useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom';
import { Icon } from '@iconify/react';

import PageHeader from 'src/components/shared/page-header';
import TeamDetails, { type FilterType } from 'src/components/teams/details';
import StatusFilter from 'src/components/shared/status-filter';

const TeamDetailPage: React.FC = () => {
  const [filter, setFilter] = useState<FilterType>('all');
  const [isTimeclockMode, setIsTimeclockMode] = useState(false);
  const [searchParams,] = useSearchParams();
  const params = useParams()
  const teamName =searchParams.get('name') ?? ''

  return (
    <div className="min-h-screen w-full flex flex-col">
      <PageHeader
        title={teamName}
        isDetail
        rightContent={
          <div className="flex items-center gap-2">
            <button
              onClick={() => setIsTimeclockMode(!isTimeclockMode)}
              className={`p-2 text-sm font-medium rounded-lg border transition-colors flex items-center justify-center ${
                isTimeclockMode
                  ? 'border-green-700 bg-green-700 text-white hover:bg-green-800'
                  : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
              }`}
              title='Time view'
            >
              <Icon icon="lucide:clock" width={20} />
            </button>
            <StatusFilter value={filter} onChange={setFilter} />
          </div>
        }
      />
      <div className="flex items-center flex-col gap-2">
        <TeamDetails teamId={params?.teamId!} filter={filter} isTimeclockMode={isTimeclockMode} />
      </div>
    </div>
  )
}

export default TeamDetailPage